import PropTypes from 'prop-types';

export const HeroActionPropType = {
  as: PropTypes.string,
  label: PropTypes.string | PropTypes.node,
  to: PropTypes.string,
  icon: PropTypes.func,
};
